import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useAuthState } from "../../context/AuthContext";
import { CourseForm } from "../../components/course/CourseForm";
import { loadAllCourses } from "../../lib/api/course";

const Home = () => {
  const navigate = useNavigate();
  const {
    loggedUser: { roler },
  } = useAuthState();
  const [courses, setCourses] = useState([]);

  const requestAllCourses = useCallback(async () => {
    const { courses } = await loadAllCourses();
    setCourses(courses);
  }, []);

  useEffect(() => {
    requestAllCourses();
  }, [requestAllCourses]);

  const handleView = (e) => {
    const id = e.target.value;
    navigate(`/courses/${id}`);
  };

  return (
    <div>
      <Container fluid="md">
        {courses ? (
          <CourseForm
            isAdmin={roler === "admin"}
            courses={courses}
            handleView={handleView}
          />
        ) : undefined}
      </Container>
    </div>
  );
};

export default Home;
